"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AfterPluginsInstallationHook = exports.BeforePluginsInstallationHook = void 0;
const hooks_1 = require("../hooks");
/**
 * Hook executed before the installation of the plugins
 */
class BeforePluginsInstallationHook extends hooks_1.BaseHook {
    constructor(sender, applicationContext, sortedPlugins) {
        super(sender);
        this.applicationContext = applicationContext;
        this.sortedPlugins = sortedPlugins;
    }
}
exports.BeforePluginsInstallationHook = BeforePluginsInstallationHook;
/**
 * Hook executed after the installation of the plugins
 */
class AfterPluginsInstallationHook extends hooks_1.BaseHook {
    constructor(sender, applicationContext, sortedPlugins) {
        super(sender);
        this.applicationContext = applicationContext;
        this.sortedPlugins = sortedPlugins;
    }
}
exports.AfterPluginsInstallationHook = AfterPluginsInstallationHook;
//# sourceMappingURL=hooks.js.map